export default "__VITE_ASSET__7f1b1cd3__"